import Plural from './Plural'
export default Plural
